import CancelButton from "molecules/buttons/cancel-button";
import DoneButton from "molecules/buttons/done-button";
import React from "react";
import { PropsWithChildren } from "react";

type AnyFunction = (...args: any[]) => any;

interface PageBlockToolbarWrapperProps extends PropsWithChildren {
    onDone: AnyFunction | null | undefined;
    onCancel?: AnyFunction;
}

const CSS_CLASS_NAME = "c-page-block-toolbar-wrapper";

const PageBlockToolbarWrapper = (props: PageBlockToolbarWrapperProps) => {
    const { children, onDone, onCancel } = props;
    return (
        <section className={CSS_CLASS_NAME}>
            <div className={`${CSS_CLASS_NAME}__wrapper`}>
                <div className={`${CSS_CLASS_NAME}__scrollWrapper`}>
                    {children}
                </div>
                <div className={`${CSS_CLASS_NAME}__fixedWrapper`}>
                    {onDone && <DoneButton onDone={onDone} />}
                    {onCancel && <CancelButton onCancel={onCancel} />}
                </div>
            </div>
        </section>
    );
};

export default PageBlockToolbarWrapper;
